import { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, Link as RouterLink } from 'react-router-dom';

import {
    Card,
    Stack,
    Avatar,
    Button,
    Container,
    Typography,
    ListItemIcon,
    Box,
    Tooltip,

} from '@mui/material';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MUIDataTable from 'mui-datatables';
import Iconify from '../../components/iconify';
import Modals from '../../components/modals/modal';
import { AlertDialog } from '../../utils/dealog/diloag';
import { apiUrl, } from '../../utils/api';
import { showSuccess, showError } from '../../utils/toast';
// Redux 
import { useGetCityQuery, useGetAriaQuery } from '../../redux/services/common/Common';
import { useGetSallerApiMutation, useActivateApiMutation, useApprovelApiMutation } from '../../redux/services/seller/seller';

const columns = [
    {
        name: 'logo',
        label: '',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: 'name',
        label: 'Name',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: 'address',
        label: 'Address',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: 'status',
        label: 'Status(Approval)',
        options: {
            filter: true,
            sort: true,
        },
    },
    {
        name: 'action',
        label: 'Action',
        options: {
            filter: false,
            sort: false,
        },
    },
];
const options = {
    filterType: 'dropdown',
};
const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.Logo}${path}`;
    return (
        <Avatar alt={name} src={url} />

    )
}
const DataName = ({ id, name, }) => {

    return (
        <>
            <Button variant="text" component={RouterLink} to={`/seller-info/${id}`}>{name}</Button>
        </>
    )
}

const DataAddress = ({ address }) => {
    if (address.length > 50) {
        return (<Typography variant="body" >
            {address.substring(0, 50)}<br /> {address.substring(50)}
        </Typography>)
    }
    return (
        <Typography variant="body" >
            {address}
        </Typography>
    )
}

const ActionButtons = ({ seller, openInfoUpdate }) => {
    return (
        <>
            <Button onClick={() => { openInfoUpdate(seller) }} >
                <ListItemIcon style={{ justifyContent: 'left' }}>
                    <Iconify icon="eva:edit-fill" width={24} height={24} color="blue" />
                </ListItemIcon>
            </Button>
        </>
    )
};


const DeactivateButton = ({ seller, onDeactove, openInfoUpdate }) => (
    <>
        <Stack spacing={2} direction="row" sx={{ display: 'flex', justifyContent: "center" }}>
            <Tooltip title="Deactivate">
                <Button onClick={() => onDeactove(seller)} >
                    <ListItemIcon style={{ justifyContent: 'center' }}>
                        <Iconify icon="bxs:user-x" width={24} height={24} />
                    </ListItemIcon>
                </Button>
            </Tooltip>
        </Stack>
    </>
)

const ActivateButton = ({ seller, onActivate, openInfoUpdate }) => (

    <>
        <Stack spacing={2} direction="row" sx={{ display: 'flex', justifyContent: "center" }}>
            <Tooltip title="Activate">
                <Button onClick={() => onActivate(seller)} >
                    <ListItemIcon style={{ justifyContent: 'center' }}>
                        <Iconify icon="bxs:user-check" width={24} height={24} sx={{ color: 'greenyellow' }} />
                    </ListItemIcon>
                </Button>
            </Tooltip>
        </Stack>
    </>

)

const SellerApprovel = ({ seller, onApprovel }) => (

    <>
        <Tooltip title="Verified" onClick={() => onApprovel(seller)}>
            <Button >
                <ListItemIcon style={{ justifyContent: "center", color: "greenyellow" }}>
                    <Iconify icon="bxs:user-check" width={24} height={24} />
                </ListItemIcon>
            </Button>
        </Tooltip>
    </>





)

const SellerNotApprovel = ({ seller, notApprovel }) => (
    <>

        <Tooltip title="Not Verified" onClick={() => notApprovel(seller)}>
            <Button >
                <ListItemIcon style={{ justifyContent: "center", color: "red" }}>
                    <Iconify icon="bxs:user-x" width={24} height={24} />
                </ListItemIcon>
            </Button>
        </Tooltip>

    </>
)


export default function SellerPage() {
    // redux Api Caling

    const navigate = useNavigate();

    const [row, setRow] = useState([])
    const [active, setActive] = useState();
    const [Approval, setApproval] = useState();
    const [loadSeller, setLoadSeller] = useState(true)

    //dropdown
    const [selectedCity, setSelectedCity] = useState();
    const [selectedPincode, setSelectedPincode] = useState(null)
    const [selectApproval, setSelectApproval] = useState(null)
    const [selectActive, setSelectActive] = useState(null)

    const [loadCity, setLoadCity] = useState(true)
    const [cityList, setCityList] = useState()
    const [pincodeList, setPincodeList] = useState()
    const [reloadData, setReloadData] = useState(false)

    // modal
    const [showActivete, setShowActivete] = useState(false)
    const [showApprovel, setShowApprovel] = useState(false)

    const sellerActive = useRef()
    const activeteMassege = useRef()
    const activeteTitele = useRef()
    const sellerApprovels = useRef()
    const ApprovelMassege = useRef()
    const ApprovelTitele = useRef()

    const { data: getCitys } = useGetCityQuery()
    const { data: getPincode, } = useGetAriaQuery(selectedCity)

    const [getSellerData, SallerData] = useGetSallerApiMutation()
    const [getActiveteData, ActiveteSeller] = useActivateApiMutation()
    const [getApprovelApi, ApprovelApi] = useApprovelApiMutation()








    const sallerList = async () => {
        const requestData = {
            'verified': selectApproval,
            'active': selectActive,
            'pincode': selectedPincode,
            'city': selectedCity
        };

        try {
            console.log('Search seller', selectedCity, selectedPincode, selectApproval, selectActive);

            const result = await getSellerData(requestData);

            console.log("sellerData", result.data.sellers);

            if (result && result.data.sellers) {
                const data = [];

                result.data.sellers.forEach(
                    (item) => {
                        let actionButtons = null;
                        if (item.active) {
                            actionButtons = <DeactivateButton seller={item} onDeactove={onShowDeactivate} />
                        } else {
                            actionButtons = <ActivateButton seller={item} onActivate={onShowActivate} />
                        }
                        let approvelButton = null;
                        if (item.verified) {
                            approvelButton = <SellerNotApprovel seller={item} notApprovel={onShowNotApprovel} />
                        } else {
                            approvelButton = <SellerApprovel seller={item} onApprovel={onShowApprovel} />
                        }
                        data.push(
                            {
                                logo: <DataLogo path={item.logo} name={item.business_name} sellers={item.id} />,
                                name: <DataName id={item.id} name={item.business_name} />,
                                address: <DataAddress address={item.address} />,
                                status: approvelButton,
                                action: actionButtons
                            }
                        )
                    }
                )
                setRow(data);

            } else {
                console.error("Invalid API response:", result);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setRow([]);
            showError(SallerData.isError);
        }
    }



    // selecter
    useEffect(() => {

        console.log('Search seller', selectedCity, selectedPincode, selectApproval, selectActive);


        if (selectedCity == null && selectedPincode == null && selectApproval == null && selectActive == null) {
            return
        }
        setReloadData(false);

        sallerList()


    }, [selectedCity, selectedPincode, selectActive, selectApproval, reloadData]);

    useEffect(() => {
        setLoadCity(false);

        const citydata = getCitys
        setSelectedCity(citydata?.data);

        if (citydata?.data?.length > 0) {
            setSelectedCity(citydata?.data[0]?.id)
        }



        if (selectedCity == null) {
            return
        }


        setSelectedPincode(0);

    }, [loadCity, selectedCity]);







    const handleChangeCity = (event) => {
        const selectedValue = event.target.value;
        setSelectedCity(selectedValue);
        if (selectedValue === 0) {
            setSelectedPincode(null);
        }
    }
    const handleChangePincode = (event) => {
        setSelectedPincode(event.target.value)
    }
    const handleChangeApproval = (event) => {
        setSelectApproval(event.target.value)
    }
    const handleChangeActive = (event) => {
        setSelectActive(event.target.value)
    }


    const onShowDeactivate = (seller) => {
        sellerActive.current = seller
        activeteMassege.current = `Deactivete ${seller.business_name}!`
        activeteTitele.current = `Do you want deactivate ${seller.business_name}?`
        setShowActivete(true)
    }

    const onShowActivate = (seller) => {
        sellerActive.current = seller
        activeteMassege.current = `Activete ${seller.business_name}!`
        activeteTitele.current = `Do you want activete ${seller.business_name}?`
        setShowActivete(true)
    }

    const onActivateSeller = async (seller) => {

        console.log(sellerActive.current.id)
        const status = sellerActive.current.active ? 'D' : 'A'

        const body = {
            status: status,
            seller: sellerActive.current.id
        }

        await getActiveteData(body)
        setReloadData(true);

        setShowActivete(false);
    }

    useEffect(() => {
        if (ActiveteSeller.isSuccess) {
            showSuccess('Activate Success');
            ActiveteSeller.reset();
        }
        if (ActiveteSeller.isError) {
            showError('Activate Error');
            ActiveteSeller.reset();
        }
    }, [ActiveteSeller])

    const onShowNotApprovel = (seller) => {
        sellerApprovels.current = seller
        ApprovelMassege.current = `Not Approvel ${seller.business_name}!`
        ApprovelTitele.current = `Do you want Not Approve ${seller.business_name}?`
        setShowApprovel(true)
    }

    const onShowApprovel = (seller) => {
        sellerApprovels.current = seller
        ApprovelMassege.current = `Approvel ${seller.business_name}!`
        ApprovelTitele.current = `Do you want Approv ${seller.business_name}?`
        setShowApprovel(true)
    }

    const onProvelSeller = async (seller) => {

        console.log(sellerApprovels.current.id)
        const status = sellerApprovels.current.verified ? 'D' : 'A'
        const body = {
            status: status,
            seller: sellerApprovels.current.id
        }

        await getApprovelApi(body)
        setReloadData(true);

        setShowApprovel(false);
    }

    useEffect(() => {
        if (ApprovelApi.isSuccess) {
            showSuccess(' Success');
            ApprovelApi.reset();
        }
        if (ApprovelApi.isError) {
            showError(' Error');
            ApprovelApi.reset();
        }
    }, [ApprovelApi])


    const onCloseActivete = () => {
        setShowActivete(false)
    }
    const onCloseApprovel = () => {
        setShowApprovel(false)
    }



    return (
        <>
            <Helmet>
                <title> Seller | FoodsyIndia </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Seller
                    </Typography>
                </Stack>
                <Card>
                    <Box sx={{ flexGrow: 1 }} style={{ margin: "30px" }}>
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">City</InputLabel>
                                    <Select
                                        margin="dense"
                                        variant="outlined"
                                        label="City"
                                        name="City"
                                        fullWidth
                                        value={selectedCity}
                                        onChange={handleChangeCity}
                                    >

                                        {getCitys && getCitys?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Pincode</InputLabel>
                                    <Select
                                        margin="dense"
                                        variant="outlined"
                                        label="Pincode"
                                        name="Pincode"
                                        fullWidth
                                        value={selectedPincode}
                                        onChange={handleChangePincode}
                                    >

                                        {getPincode && getPincode?.data?.map((opetion) => <MenuItem key={opetion?.id} value={opetion?.id}>{opetion?.pincode}</MenuItem>)}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Approval</InputLabel>
                                    <Select
                                        margin="dense"
                                        variant="outlined"
                                        label="Approval"
                                        name="Approval"
                                        value={Approval}
                                        fullWidth
                                        onChange={handleChangeApproval}
                                    >
                                        <MenuItem value={'Y'}>Yes</MenuItem>
                                        <MenuItem value={'N'}>No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Active</InputLabel>
                                    <Select
                                        margin="dense"
                                        variant="outlined"
                                        label="Active"
                                        name="Active"
                                        value={active}
                                        fullWidth
                                        onChange={handleChangeActive}
                                    >
                                        <MenuItem value={'Y'}>Yes</MenuItem>
                                        <MenuItem value={'N'}>No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                </Card>
                <br />
                <br />
                {SallerData.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> :
                    (
                        <Card>
                            <MUIDataTable title={'Seller'} data={row} columns={columns} options={options} />
                        </Card>
                    )
                }
            </Container>




            <AlertDialog open={showActivete} message={activeteMassege} title={activeteTitele} onCancel={onCloseActivete} onOkey={onActivateSeller} />
            <AlertDialog open={showApprovel} message={ApprovelMassege} title={ApprovelTitele} onCancel={onCloseApprovel} onOkey={onProvelSeller} />

        </>
    );
}


